//Dependencies
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Webcam from "react-webcam";
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import TagManager from 'react-gtm-module'
import 'typeface-roboto';
import axios from 'axios';

//Material UI
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

//Reducers
//cargamos nuestros reducers(ya combinados)
import { store, persistor } from './store/configure';

// Routes
import AppRoutes from './Routes';


const tagManagerArgs = {
    gtmId: 'GTM-NZN8BML'
}

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#ff7043',
            main: '#f47321',
            dark: '#f47321',
            contrastText: '#FFF',
        },
    },
    overrides: {
        MuiInput: {
            underline: {
                "&&&&:hover:before": {
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
                }
            }
        }
    },
    typography: { useNextVariants: true },
});

axios.interceptors.request.use(function(config) {
	config.withCredentials = false;
	var uuidbb = localStorage.getItem('uuidbb');
	if (uuidbb) {
		config.headers.uuid = uuidbb;
	}
	return config;
}, function (error) {
	return Promise.reject(error);
});

axios.interceptors.response.use(function(response) {
	try {
		var uuid = response.data.uuid;
		if (uuid) {
			localStorage.setItem('uuidbb', uuid);
		}
    }
    catch (error) {
	}
    return response;
}, function (error) {
	return Promise.reject(error);
});


TagManager.initialize(tagManagerArgs)
ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router basename={'/onboarding'}>
                    <AppRoutes />
                </Router>
            </PersistGate>
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root'));
//registerServiceWorker(); 
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
        registration.unregister().then(() => {
          window.location.reload();
        });
    });
}




// WEBPACK FOOTER //
// ./src/index.js